// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--20051","text":"_93444fe79c--text--2UnSp","close":"_93444fe79c--close--a88C8","hands-ver1":"_93444fe79c--hands-ver1--395f7"};